import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
// Vite resolves worker URL for pdf.js
import pdfWorkerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

let pdfWorkerConfigured = false;

function ensurePdfWorker() {
  if (pdfWorkerConfigured) return;
  GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
  pdfWorkerConfigured = true;
}

const MAX_CHARS = 12000;

/** Extract plain text from a PDF (first pages until limit). */
export async function extractPdfText(file: File): Promise<string> {
  ensurePdfWorker();
  const data = await file.arrayBuffer();
  const pdf = await getDocument({ data }).promise;
  let out = '';
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const textContent = await page.getTextContent();
    const pageText = textContent.items
      .map((item) => ('str' in item ? (item as { str: string }).str : ''))
      .join(' ');
    out += `${pageText}\n`;
    if (out.length >= MAX_CHARS) break;
  }
  return out.trim().slice(0, MAX_CHARS);
}

/** Extract plain text from a Word .docx file. */
export async function extractDocxText(file: File): Promise<string> {
  const mammoth = await import('mammoth');
  const arrayBuffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer });
  return (result.value || '').trim().slice(0, MAX_CHARS);
}
